import { RouteConfig } from "vue-router";

export const REmployerPricing: RouteConfig = {
  path: "pricing",
  name: "Pricing",
  component: () =>
    import(
      /* webpackChunkName: "employer-pricing" */
      "./VEmployerPricing.vue"
    ),
  meta: {
    title: "Pricing",
    icon: "cash-outline",
    newIcon: "coin-pound",
    version: 2,
  },
};
